import { Stack, Typography } from '@mui/material';

function isAffected(dataSet) {
  return dataSet.uuid.includes('affected');
}

export function DataSetAccuracy({ dataSet }) {
  const sx = {
    textAlign: 'center',
    width: '100%',
  };

  return (
    <>
      {dataSet.dataSetType === 'FACE' && isAffected(dataSet) && <Typography sx={sx}>Sensitivity: {dataSet.evaluation.faceSensitivity}</Typography>}
      {dataSet.dataSetType === 'FACE' && isAffected(dataSet) && <Typography sx={sx}>Side accuracy: {dataSet.evaluation.faceSideAccuracy}</Typography>}
      {dataSet.dataSetType === 'FACE' && !isAffected(dataSet) && <Typography sx={sx}>Specificity: {dataSet.evaluation.faceSpecificity}</Typography>}
      {dataSet.dataSetType === 'SPEECH' && isAffected(dataSet) && <Typography sx={sx}>Sensitivity: {dataSet.evaluation.speechSensitivity}</Typography>}
      {dataSet.dataSetType === 'SPEECH' && !isAffected(dataSet) && <Typography sx={sx}>Specificity: {dataSet.evaluation.speechSpecificity}</Typography>}
      {dataSet.dataSetType === 'ARMS' && isAffected(dataSet) && <Typography sx={sx}>Sensitivity: {dataSet.evaluation.armsSensitivity}</Typography>}
      {dataSet.dataSetType === 'ARMS' && isAffected(dataSet) && <Typography sx={sx}>Accuracy with side: {dataSet.evaluation.armsSensitivityWithSide}</Typography>}
      <Stack direction="row">
        {dataSet.dataSetType === 'ARMS' && isAffected(dataSet) && <Typography sx={sx}>Left arm sensitivity: {dataSet.evaluation.leftArmSensitivity}</Typography>}
        {dataSet.dataSetType === 'ARMS' && isAffected(dataSet) && <Typography sx={sx}>Right arm sensitivity: {dataSet.evaluation.rightArmSensitivity}</Typography>}
      </Stack>

      {dataSet.dataSetType === 'ARMS' && !isAffected(dataSet) && <Typography sx={sx}>Specificity: {dataSet.evaluation.armsSpecificity}</Typography>}
    </>
  );
}
